import {
	ProductGroupForSaleDTO,
	ProductForSaleDTO,
	AddinRoleDTO,
	ProductDetailsDTO,
	MenuForSaleDTO,
	ProductAvailabilityDTO,
	GetProductGroupsForSaleRequest,
	GetProductGroupsForSaleResponse,
	ProductGroupType,
	GetSaleableAsMainByProductGroupRequest,
	GetSaleableAsMainByProductGroupResponse,
	GetSaleableAsMainFormatsByProductRequest,
	GetSaleableAsMainFormatsByProductResponse,
	GetSaleableAsMenuItemFormatsByProductRequest,
	GetSaleableAsMenuItemFormatsByProductResponse,
	GetSaleableAsMainByProductIdRequest,
	GetSaleableAsMainByProductIdResponse,
	GetAddinRolesBySaleFormatRequest,
	GetAddinRolesBySaleFormatResponse,
	GetSaleableAsAddinByRoleRequest,
	GetSaleableAsAddinByRoleResponse,
	GetSaleableAsMainBySaleFormatIdRequest,
	GetSaleableAsMainBySaleFormatIdResponse,
	GetMenuForSaleRequest,
	GetMenuForSaleResponse,
	GetSaleableAsMenuItemByProductGroupRequest,
	GetSaleableAsMenuItemByProductGroupResponse,
	ParseBarcodeRequest,
	ParseBarcodeResponse,
	GetProductDetailsInPosResponse,
	GetSaleableAsMainByPriceLookUpCodeRequest,
	GetSaleableAsMainByPriceLookUpCodeResponse,
	GetProductAvailableQuantitiesByPosRequest,
	GetProductAvailableQuantitiesByPosResponse,
	SetProductAvailableQuantitiesRequest,
	AddProductToCategoryRequest,
	GetMenusToConfigureRequest,
	GetMenusToConfigureResponse,
	GetProductGroupsForMenuConfigurationRequest,
	GetProductGroupsForMenuConfigurationResponse,
	GetProductsForMenuConfigurationByCategoryRequest,
	GetProductsForMenuConfigurationByCategoryResponse,
	GetProductsForMenuConfigurationByFamilyRequest,
	GetProductsForMenuConfigurationByFamilyResponse,
	MenuConfigurationDTO,
	MenuGroupConfigurationDTO,
	ProductForMenuConfigurationDTO,
	RemoveProductFromCategoryRequest,
	GetSaleableAsMainByTextRequest,
	GetSaleableAsMainByTextResponse,
	ParseBarcodeResultDTO,
	GetProductDetailsInPosRequest,
	SizesAndColorsDTO,
	GetSizesAndColorsRequest,
	GetSizesAndColorsResponse,
	GetPrintMenuPreviewRequest,
	GetPrintMenuPreviewResponse,
	PrintPreviewDTO,
	PrintMenuRequest,
	PrintMenuResponse,
	GetInstalledPrintersRequest,
	GetInstalledPrintersResponse
} from 'core/api';

import { Bus } from 'core/infrastructure';
import { SessionProvider } from 'core/infrastructure';

const process = Bus.buildProcessFn('/bus/');

export function getProductGroups(saleCenterId: number): Promise<ProductGroupForSaleDTO[]> {
	const request = new GetProductGroupsForSaleRequest({ saleCenterId });
	return process(request, (response: GetProductGroupsForSaleResponse) => response.ProductGroups);
}

export function getSaleableAsMainByProductGroup(productGroupType: ProductGroupType, productGroupId: number, ticketId: number): Promise<ProductForSaleDTO[]> {
	const request = new GetSaleableAsMainByProductGroupRequest({ productGroupType, productGroupId, ticketId });
	return process(request, (response: GetSaleableAsMainByProductGroupResponse) => response.Products);
}

export function getSaleableAsMainFormatsByProduct(productId: number, ticketId: number): Promise<ProductForSaleDTO[]> {
	const request = new GetSaleableAsMainFormatsByProductRequest({ productId, ticketId });
	return process(request, (response: GetSaleableAsMainFormatsByProductResponse) => response.Formats);
}

export function getSaleableAsMenuItemFormatsByProduct(productId: number, ticketId: number): Promise<ProductForSaleDTO[]> {
	const request = new GetSaleableAsMenuItemFormatsByProductRequest({ productId, ticketId });
	return process(request, (response: GetSaleableAsMenuItemFormatsByProductResponse) => response.Formats);
}

export function getSaleableAsMainByProductId(productId: number, ticketId: number): Promise<ProductForSaleDTO> {
	const request = new GetSaleableAsMainByProductIdRequest({ productId, ticketId });
	return process(request, (response: GetSaleableAsMainByProductIdResponse) => response.Product);
}

export function getAddinRolesBySaleFormat(saleFormatId: number): Promise<AddinRoleDTO[]> {
	const request = new GetAddinRolesBySaleFormatRequest({ saleFormatId });
	return process(request, (response: GetAddinRolesBySaleFormatResponse) => response.Roles);
}

export function getSaleableAsAddinByRole(addinRoleId: number, ticketId: number, isAddinInMenu: boolean): Promise<ProductForSaleDTO[]> {
	const request = new GetSaleableAsAddinByRoleRequest({ addinRoleId, ticketId, isAddinInMenu });
	return process(request, (response: GetSaleableAsAddinByRoleResponse) => response.AllowedAddins);
}

export function getSaleableAsMainBySaleFormatId(saleFormatId: number, ticketId: number): Promise<ProductForSaleDTO> {
	const request = new GetSaleableAsMainBySaleFormatIdRequest({ saleFormatId, ticketId });
	return process(request, (response: GetSaleableAsMainBySaleFormatIdResponse) => response.Product);
}

export function getMenuForSale(saleFormatId: number): Promise<MenuForSaleDTO> {
	const request = new GetMenuForSaleRequest({ saleFormatId });
	return process(request, (response: GetMenuForSaleResponse) => response.MenuForSale);
}

export function getSaleableAsMenuItemByProductGroup(productGroup: ProductGroupForSaleDTO, ticketId: number): Promise<ProductForSaleDTO[]> {
	const request = new GetSaleableAsMenuItemByProductGroupRequest({ productGroup, ticketId });
	return process(request, (response: GetSaleableAsMenuItemByProductGroupResponse) => response.Products);
}

export function parseBarcode(barcode: string, ticketId: number): Promise<ParseBarcodeResultDTO> {
	const request = new ParseBarcodeRequest({ barcode, ticketId });
	return process(request, (response: ParseBarcodeResponse) => response.Result);
}

export function getSaleableAsMainByPLU(priceLookUpCode: string, ticketId: number): Promise<ProductForSaleDTO> {
	const request = new GetSaleableAsMainByPriceLookUpCodeRequest({ priceLookUpCode, ticketId });
	return process(request, (response: GetSaleableAsMainByPriceLookUpCodeResponse) => response.Product);
}

export async function loadProductDetails(saleCenterId: number, saleFormatId: number): Promise<ProductDetailsDTO> {
	const request = new GetProductDetailsInPosRequest({ saleCenterId, saleFormatId });
	return await process(request, (response: GetProductDetailsInPosResponse) => response.Details);
}

export async function getProductAvailableQuantities(): Promise<ProductAvailabilityDTO[]> {
	const request = new GetProductAvailableQuantitiesByPosRequest();
	return await process(request, (response: GetProductAvailableQuantitiesByPosResponse) => response.Quantities);
}

export async function setProductAvailableQuantities(quantities: ProductAvailabilityDTO[]): Promise<void> {
	const request = new SetProductAvailableQuantitiesRequest({ quantities });
	await process(request);
}

export function getMenus(): Promise<MenuConfigurationDTO[]> {
	const request = new GetMenusToConfigureRequest();
	return process(request, (response: GetMenusToConfigureResponse) => response.Menus);
}

export function getProductsByMenuGroup(group: MenuGroupConfigurationDTO): Promise<ProductForMenuConfigurationDTO[]> {
	const request = new GetProductsForMenuConfigurationByCategoryRequest({ categoryId: group.ItemsCategoryId });
	return process(request, (response: GetProductsForMenuConfigurationByCategoryResponse) => response.Products);
}

export function removeProductFromMenuGroup(group: MenuGroupConfigurationDTO, product: ProductForMenuConfigurationDTO): Promise<void> {
	const request = new RemoveProductFromCategoryRequest({ categoryId: group.ItemsCategoryId, productId: product.Id });
	return process(request);
}

export function getAllProductGroupsForMenu(): Promise<ProductGroupForSaleDTO[]> {
	const request = new GetProductGroupsForMenuConfigurationRequest();
	return process(request, (response: GetProductGroupsForMenuConfigurationResponse) => response.ProductGroups);
}

export function getProductsByFamilyForMenu(familyId: number): Promise<ProductForMenuConfigurationDTO[]> {
	const request = new GetProductsForMenuConfigurationByFamilyRequest({ familyId });
	return process(request, (response: GetProductsForMenuConfigurationByFamilyResponse) => response.Products);
}

export function getProductsByCategoryForMenu(categoryId: number): Promise<ProductForMenuConfigurationDTO[]> {
	const request = new GetProductsForMenuConfigurationByCategoryRequest({ categoryId });
	return process(request, (response: GetProductsForMenuConfigurationByCategoryResponse) => response.Products);
}

export function addProductToMenuGroup(group: MenuGroupConfigurationDTO, product: ProductForMenuConfigurationDTO): Promise<void> {
	const request = new AddProductToCategoryRequest({ categoryId: group.ItemsCategoryId, productId: product.Id });
	return process(request);
}

export async function searchProductByText(ticketId: number, text: string, onlyThisPos: boolean): Promise<{ products: ProductForSaleDTO[], maxResults: number }> {
	const onlyInPosId = onlyThisPos ? SessionProvider.getCurrent().PosId : null;
	const request = new GetSaleableAsMainByTextRequest({ ticketId, text, onlyInPosId });
	return process(request, (response: GetSaleableAsMainByTextResponse) => ({ products: response.Products, maxResults: response.MaxResults }));
}

export async function getSizesAndColorsByProductId(productId: number): Promise<SizesAndColorsDTO> {
	const request = new GetSizesAndColorsRequest({ productId });
	return process(request, (response: GetSizesAndColorsResponse) => response.SizesAndColors);
}

export async function getMenuPrintPreview(menu: MenuConfigurationDTO): Promise<PrintPreviewDTO> {
	const request = new GetPrintMenuPreviewRequest({ menu });
	return process(request, (response: GetPrintMenuPreviewResponse) => response.Preview);
}

export async function printMenu(menu: MenuConfigurationDTO, printerName: string, copies: number): Promise<PrintMenuResponse> {
	const request = new PrintMenuRequest({ menu, printerName, copies });
	return process(request, (response: PrintMenuResponse) => response);
}

export async function getInstalledPrinters(): Promise<string[]> {
	const request = new GetInstalledPrintersRequest({});
	return process(request, (response: GetInstalledPrintersResponse) => response.Printers);
}